import React, { Component } from "react";
import NavMenu from "../../navmenu/NavMenu";
import ProjectHeader from "./ProjectHeader";
import ProjectImage from "./ProjectImage";
import bigImage from "../../../assets/images/the-good-fight-desktop-header.jpg";
import "../../../styles/pages/projects/Project.css";
import mobile1 from "../../../assets/images/the-good-fight-mobile-1.png";
import mobile2 from "../../../assets/images/the-good-fight-mobile-2.png";
import gif from "../../../assets/images/the-good-fight-gif.gif";
import ProjectConclusion from "./ProjectConclusion";
import Footer from "../../footer/Footer";
import onScrollHandler from "../../../utilities/onScrollHandler";
import NextPrompt from "../../nextprompt/NextPrompt";

export default class TheGoodFight extends Component {
  componentDidMount() {
    this.onScrollHandler = new onScrollHandler();
  }
  render() {
    return (
      <div className="TheGoodFight page-wrapper">
        <NavMenu />
        <ProjectHeader
          title="THE GOOD FIGHT"
          year="2019"
          contributions={["Web Design", "Website Development", "Copywriting"]}
          projectLink={"#"}
          description={
            <div>
              The Good Fight was a charity helping those affected by Hurricane
              Michael. Unfortunately, this project never got published - But we
              are still very proud of it and happy to show it off.
              <br />
              <br />
              The project consisted of informing the user about the disaster,
              allowing them to donate, and letting them know the different ways
              they could help the cause.
            </div>
          }
        />
        <ProjectImage
          projectName={"The Good Fight"}
          layout={"big-image"}
          image={bigImage}
          backgroundColor={"#868686"}
        />
        <div className="gutters">
          <div className="project-text g-sub-text on-scroll-anim">
            Finding images and media for the website was a major hurdle. All of
            the images on the site are sourced from Google Maps.
            <br />
            <br />
            The homepage header background is an interactive split image of a
            neighborhood before and after the disaster.
          </div>
        </div>
        <ProjectImage
          projectName={"The Good Fight"}
          layout={"gif-showcase"}
          mobileImages={[mobile1, mobile2]}
          gif={gif}
          backgroundColor={"#868686"}
        />
        <ProjectConclusion
          text={
            <div>
              This is a site we are very proud of, and we wish we could have
              seen it take effect in the real world. Regardless, it was a great
              experience to create, and the challenges that it provided taught
              us a lot about design and copywriting.
            </div>
          }
        />

        <NextPrompt />
        <Footer page={"thegoodfight"} />
      </div>
    );
  }
}
